module.exports = __webpack_public_path__ + "img/verticle.5e16cbe4.svg";